import { useEffect, useState } from 'react';

import { ClientPause, isPauseActive, nextPauseBoundary } from '~/types/client/pause';

// setTimeout plafonne à ~24,8 jours ; on revérifie au moins toutes les 6 h.
const MAX_WAIT_MS = 6 * 60 * 60 * 1000;

/**
 * La pause coupe-t-elle l'accès MAINTENANT ? Se réévalue pile au début et à la
 * fin de la pause : une TV peut rester des heures sur le menu sans nouvel
 * instantané Firestore (le changement d'état est temporel, pas une écriture).
 */
export function usePauseActive(pause: ClientPause | undefined | null): boolean {
    const [tick, setTick] = useState(0);
    const startsAt = pause?.startsAt ?? null;
    const resumesAt = pause?.resumesAt ?? null;
    const status = pause?.status;

    useEffect(() => {
        const boundary = nextPauseBoundary(pause);
        if (boundary == null) return undefined;
        const wait = Math.min(Math.max(boundary - Date.now(), 0) + 500, MAX_WAIT_MS);
        const timer = setTimeout(() => setTick((n) => n + 1), wait);
        return () => clearTimeout(timer);
        // Clés primitives (l'objet pause est recréé à chaque instantané) + tick :
        // après une attente plafonnée, on reprogramme la suivante.
    }, [status, startsAt, resumesAt, tick]);

    return isPauseActive(pause);
}
